import { ref } from '@vue/composition-api'
import type { UserAggregationAssignTemplate } from '@/api/v2/employee/user-management/UserAggregationAssignTemplate'
import UserAggregationAssignTemplateApi from '@/api/v2/employee/user-management/UserAggregationAssignTemplate'

export default function useAggregationCatalogs() {
  const aggregationCatalogs = ref<UserAggregationAssignTemplate[]>([])

  // ラベルの一覧を取得
  const getAggregationCatalogs = async () => {
    const res = await UserAggregationAssignTemplateApi.getUserAggregationAssignTemplates()
    aggregationCatalogs.value = res
  }

  return {
    aggregationCatalogs,
    getAggregationCatalogs,
  }
}
